import CustomButton from "@/ui/Buttons/CustomButton";
import { Box, styled } from "@mui/material";
import React from "react";

//styled
const DashboardHeaderButton = styled(Box)`
  .headerButton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 20px;
    margin-top: 30px;
    h4 {
      font-weight: 600;
      font-size: 16px;
      line-height: 1.2;
      color: #121d32;
      margin: 0;
    }
    button {
      width: auto;
      @media (max-width: 575px) {
        width: 100%;
        margin: 10px 0 0;
      }
    }
  }
`;
interface BreadProps {
  children?: JSX.Element | JSX.Element[];
  name: string;
}

const DashboardHeader = ({ children, name }: BreadProps) => {
  return (
    <DashboardHeaderButton>
      <Box className="headerButton">
        <h4>{name}</h4>
        {children}
      </Box>
    </DashboardHeaderButton>
  );
};

export default DashboardHeader;
